import React, {useMemo} from 'react';
import Chart from 'react-apexcharts';

function CaseDistributionChart({data}) {
  const options = {
    labels: ['Resolved', 'Pending review'],
    colors: ['#156506', '#F6B546'],
    dataLabels: {
      enabled: false,
    },
    legend: false,
    stroke: {
      show: true,
      width: 3,
      colors: ['#FFFFFF'],
      dashArray: 0,
      lineCap: 'butt',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '91%',
          background: 'transparent',
          labels: {
            show: false,
          },
        },
        startAngle: 0,
        endAngle: 360,
        expandOnClick: false,
        customScale: 0.98,
        offsetY: 0,
      },
    },
    tooltip: {
      theme: false,
      enabled: true,
    },
    chart: {
      width: 250,
      height: 250,
      sparkline: {
        enabled: false,
      },
      animations: {
        enabled: true,
        easing: 'easeout',
        speed: 800,
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
  };

  const series = useMemo(
    () => [data?.resolvedCases, data?.unresolvedCases],
    [data],
  );

  return (
    <div className="relative flex justify-center items-center">
      <Chart type="donut" options={options} series={series} />
      <div className="absolute flex flex-col items-center w-fit">
        <span className="text-[6px] mb-2 xl:text-sm font-normal text-[#858DAA]">
          Total
        </span>
        <h1 className="font-semibold text-base xl:text-[36px] text-deepBlue">
          {new Intl.NumberFormat('en-US', {
            maximumSignificantDigits: 3,
          }).format(data?.totalCases || 0)}
        </h1>
      </div>
    </div>
  );
}

export default CaseDistributionChart;
